import { DifficultyLevel } from "myfitworld-model";
import { AllContentFilterOptions } from "src/hooks/contentFilters/useContentFilterOptions";
import { ContentFilterOptions } from "src/utils/contentFilterOptions";
import pageMessages from "src/pages/messages";
import contentMessages from "src/pages/content/messages";
export const difficultyLevels = [
  DifficultyLevel.BEGINNER,
  DifficultyLevel.MODERATE,
  DifficultyLevel.INTERMEDIATE,
  DifficultyLevel.ADVANCED,
  DifficultyLevel.OLYMPIC,
].map((level) => ({
  id: `${level}`,
  name: { en: `${level}`, sr: `${level}`, hr: `${level}`, de: `${level}`, es: `${level}` },
}));

export const getFieldConfigs = (
  options: ContentFilterOptions, 
  allFilterOptions: AllContentFilterOptions
  ) => [
    {
      name: 'sports',
      label: contentMessages.sports,
      options: allFilterOptions.SportOptions,
      isVisible: options.sports,
    },
    {
      name: 'muscleRegime',
      label: contentMessages.muscle_regime_label,
      options: allFilterOptions.muscleRegimeOptions,
      isVisible: options.muscleRegime,
    },
    {
      name: 'muscleGroups',
      label: contentMessages.primary_muscle_groups,
      options: allFilterOptions.MuscleGroupsOptions,
      isVisible: options.muscleGroups,
    },
    {
      name: 'secondaryMuscleGroups',
      label: contentMessages.secondary_muscle_groups,
      options: allFilterOptions.MuscleGroupsOptions,
      isVisible: options.secondaryMuscleGroups,
    },
    {
      name: 'fitnessActivity',
      label: contentMessages.activity,
      options: allFilterOptions.FitnessActivitiesOptions,
      isVisible: options.fitnessActivity,
    },
    {
      name: 'goals',
      label: pageMessages.goals,
      options: allFilterOptions.GoalsOptions,
      isVisible: options.goals,
    },
    {
      name: 'motorSkills',
      label: contentMessages.motor_skills,
      options: allFilterOptions.MotorSkillsOptions,
      isVisible: options.motorSkills,
    },
    {
      name: 'healthIssues',
      label: contentMessages.suitable_for_health_issues,
      options: allFilterOptions.HealthIssueOptions,
      isVisible: options.healthIssues,
    },
    {
      name: 'suitableForHealthIssues',
      label: contentMessages.suitable_for_health_issues,
      options: allFilterOptions.HealthIssueOptions,
      isVisible: options.suitableForHealthIssues,
    },
    {
      name: 'equipment',
      label: contentMessages.equipment,
      options: allFilterOptions.EquipmentOptions,
      isVisible: options.equipment,
    },
    {
      name: 'difficultyLevel',
      label: pageMessages.training_level,
      options: difficultyLevels,
      isVisible: options.difficultyLevel,
    },
    {
      name: 'goodFor',
      label: pageMessages.good_for,
      options: allFilterOptions.GoodForOptions,
      isVisible: options.goodFor,
    },
    {
      name: 'counterproductiveFor',
      label: pageMessages.counter_productive_for,
      options: allFilterOptions.CounterProductiveForOptions,
      isVisible: options.counterProductiveFor,
    },
    {
      name: 'mealTypes',
      label: contentMessages.meal_types,
      options: allFilterOptions.MealTypesOptions,
      isVisible: options.mealTypes,
    },
    {
      name: 'timePreparation',
      label: contentMessages.time_preparation,
      options: allFilterOptions.TimePreparationOptions,
      isVisible: options.timePreparation,
    },
    {
      name: 'diet',
      label: pageMessages.diet,
      options: allFilterOptions.DietOptions,
      isVisible: options.diet,
    },
    {
      name: 'micronutrient',
      label: pageMessages.micronutrients,
      options: allFilterOptions.MicroNutrientOptions,
      isVisible: options.micronutrient,
    },
    {
      name: 'category',
      label: pageMessages.category,
      options: allFilterOptions.CategoryOptions,
      isVisible: options.category,
    },
    {
      name: 'glycemicIndexRange',
      label: pageMessages.glycemic_index_range,
      options: allFilterOptions.GlycemicIndexRangeOptions,
      isVisible: options.glycemicIndexRange,
    },
    {
      name: 'glycemicLoadRange',
      label: pageMessages.glycemic_load_range,
      options: allFilterOptions.GlycemicLoadRangeOptions,
      isVisible: options.glycemicLoadRange,
    },
    {
      name: 'durationInWeeks',
      label: contentMessages.duration_in_weeks,
      options: allFilterOptions.DurationInWeeksOptions,
      isVisible: options.durationInWeeks,
    },
    {
      name: 'expertise',
      label:contentMessages.expertises,
      options: allFilterOptions.ExpertisesOptions,
      isVisible: options.expertise,
    }
];

export const shouldRenderFilterField = ({ isVisible, options }: { isVisible?: boolean; options?: any[] }) =>
  Boolean(isVisible && Array.isArray(options) && options.length > 0);
